import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {UserService} from "app/core/user/user.service";
import {ExtProfilesService} from "../../landing-publication/ext-profiles/ext-profiles.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {PublicationAccessService} from "../../landing-publication/publication-access.service";
import {UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import { IUser } from 'app/interfaces/IUser'

@UntilDestroy()
@Component({
    selector: 'app-user-details',
    templateUrl: './user-details.component.html',
    styleUrls: ['./user-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UserDetailsComponent implements OnInit {

    userExt: string[];
    ask: string[];

    fDebug: UntypedFormGroup = new UntypedFormGroup({
        'saveLabel': new UntypedFormControl('test'),
        'loadLabel': new UntypedFormControl('test'),
    })

    constructor(
        public userService: UserService,
        public extProfilesService: ExtProfilesService,
        private cdr: ChangeDetectorRef,
        public publicationAccessService: PublicationAccessService
    ) {
    }

    ngOnInit(): void {

        this.userService.user$.pipe(untilDestroyed(this)).subscribe((aUser) => {

            this.userExt = Object.keys(aUser.extProfiles);
            this.ask = this.extProfilesService.getAsk();

            this.cdr.markForCheck();

        })

    }

    saveExt(cUser: IUser) {

        const key = this.fDebug.get('saveLabel').value;
        const extStored = this.getStorage();

        extStored[key] = cUser.extProfiles;
        localStorage.setItem(`ep_${this.publicationAccessService.pubUuid}`, JSON.stringify(extStored));

    }

    getAnsweredUserExtProfileKeys(user: IUser): string[] {
      const extProfilesWithValues = Object.entries(user.extProfiles).filter((keyValuePair) => keyValuePair[1]?.length)
      return Object.values(extProfilesWithValues).map(el => el[0])
    }

    getUnansweredUserExtProfileKeys(user: IUser): string[] {
      const extProfilesWithoutValues = Object.entries(user.extProfiles).filter((keyValuePair) => !keyValuePair[1]?.length)
      return Object.values(extProfilesWithoutValues).map(el => el[0])
    }

    loadExt() {

        try {
            const key = this.fDebug.get('loadLabel').value;

            const loadedExt = this.getStorage();
            this.extProfilesService.clearExtProfiles();
            this.extProfilesService.updateMultipleExtProfiles(loadedExt[key]);
            this.extProfilesService.nextAll(); // <-- A faire avant le check pour que les pass soient à 'true'
            this.extProfilesService.checkIfAllExtCollected();

            this.fDebug.patchValue({'saveLabel': key});

        } catch (e) {

            console.log('loadExt weirdo...');

        }

    }

    clearStore() {
        localStorage.removeItem(`ep_${this.publicationAccessService.pubUuid}`);
    }

    getSavedListKey() {

        try {
            const extStored = this.getStorage();
            return Object.keys(extStored);
        } catch (e) {
            return [];
        }

    }

    getStorage(): any {
        try {

            const extStored = JSON.parse(localStorage.getItem(`ep_${this.publicationAccessService.pubUuid}`));
            if (!extStored) {
                return {};
            }
            return extStored;

        } catch (e) {
            console.log(e);
            return {};
        }

    }


    //
    //
    //
    clearExt() {
        this.extProfilesService.clearExtProfiles();
    }

    nextAllExt() {
        this.publicationAccessService.evaluatePublicationRules()
    }

}
